// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_fg-0";
export var fileCarousel = "_fg-2";
export var removeFileButton = "_fg-1";